export interface FallBackProps {
  textStructure: string;
}

export const FallBack = ({ textStructure }: FallBackProps) => (
  <span className="text-dark text-sm">{textStructure}</span>
);
